import React from 'react'
import Typography from '@/v2/components/common/Typography'
import Box from '@mui/material/Box'
import { INFOBAR_HEIGHT, TOPBAR_HEIGHT } from '@/v2/constants'
import Card from './Card'
import ContactInformation from './ContactInformation'
import EmergencyContact from './EmergencyContact'
import FamilyMembers from './FamilyMembers'
import Referrals from './Referrals'
import Tasks from './Tasks'
import MedicalAlerts from './MedicalAlerts'
import HealthHistory from './HealthHistory'
import Notes from './Notes'
import Appointments from './Appointments'
import Contract from './Contract'
import PatientInsurance from './PatientInsurance'
import { useLocation } from 'react-router-dom'

const Profile = () => {
  const hash = useLocation().hash
  const hasInsuranceForms = hash === '#patient-insurance'

  if (hasInsuranceForms) {
    const element = document.getElementById('patient-insurance')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <Box>
      <Box
        bgcolor="silver.main"
        padding={'38px 24px 60px 24px'}
        height={`calc(100vh - ${INFOBAR_HEIGHT} - ${TOPBAR_HEIGHT})`}
        overflow={'auto'}
        sx={{
          '@media (max-width: 1024px)': {
            padding: '16px',
            height: 'auto',
            minHeight: '100%',
          },
        }}
      >
        <Typography
          variant="h1"
          fontSize="26px"
          sx={{
            mb: '36px',
            '@media (max-width: 1024px)': { fontSize: '20px', mb: '20px' },
          }}
        >
          Patient Profile
        </Typography>
        <Box
          display="flex"
          flexWrap="wrap"
          minHeight="calc(100% - 66px)"
          sx={{
            '& > div:first-of-type': {
              flex: '56%',
              maxWidth: '56%',
              paddingRight: '23px',
            },
            '& > div:nth-of-type(2)': { flex: '44%', maxWidth: '44%' },
            '@media (max-width: 1024px)': {
              flexDirection: 'column',
              minHeight: 'auto',
              '& > div:first-of-type': {
                flex: '100%',
                maxWidth: '100%',
                paddingRight: 0,
              },
              '& > div:nth-of-type(2)': { flex: '100%', maxWidth: '100%' },
            },
          }}
        >
          <Box>
            <Card />
            <ContactInformation />
            <PatientInsurance />
            <EmergencyContact />
            <FamilyMembers />
            <Referrals />
          </Box>
          <Box>
            <Tasks />
            <Notes />
            <MedicalAlerts />
            <HealthHistory />
            <Contract />
            <Appointments />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Profile
